import styled from "styled-components";

export const WarningMessage = styled.p`
  align-self: center;
  margin-top: 48px;
  font-weight: var(--font-weight-semibold);
`;

export const SearchInput = styled.div`
  height: 48px;
  padding: 4px 8px;
  border: 1.6px solid var(--color-neutral-300);
  margin-top: 16px;
  border-radius: 3px;
  background-color: var(--color-contrast-white);
  display: flex;
  align-items: center;
  box-sizing: border-box;

  input {
    height: 100%;
    font-size: 16px;
    width: 100%;
    background-color: transparent;
    border: none;
    margin-left: 4px;
  }

  input:focus-visible {
    outline: none;
  }
`;

export const List = styled.dl`
  margin-top: 1em;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 4px;
  flex: 1;
  min-height: 0;
  
  ::-webkit-scrollbar {
    width: 12px; 
  }

  ::-webkit-scrollbar-track {
    background: transparent; 
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--color-neutral-400); 
    border-radius: 4px; 
    border-width: 0 4px 0 4px;
    border-style: solid;
    border-color: var(--color-neutral-background);
  }
`;

interface ListItemProps {
  isSelected: boolean;
};

export const ListItem = styled.dt<ListItemProps>`
  padding: 4px 8px;
  background-color: var(--color-contrast-white);
  border: ${(props) => (props.isSelected ? "1px solid var(--color-action-default)" : "1px solid var(--color-neutral-300)")};
  min-height: 48px;
  box-sizing: border-box;
  border-radius: 3px;
  color: ${(props) => (props.isSelected ? "var(--color-brand-300)" : "var(--color-feedback-positive-500)")};
  font-weight: var(--font-weight-semibold);
  font-size: 14px;
  text-align: justify;
  align-content: center;
  word-break: break-all;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;